
function Loading() {

    return (
		<div className="Loading" style={{ display: "none"}} id="div_loading" data-cnt="0">
			<div className="spinner"></div>
			<div> Loading... </div>
		</div>
    );
}
export default Loading;
